import React from 'react';
import { useSelector } from 'react-redux';
import useEthers from '../hooks/useEthers';
import MetaMaskIcon from './MetaMaskIcon';

const MetaMaskButton = () => {
    const { connectMetaMask, disconnectMetaMask } = useEthers();
    const account = useSelector((state) => state.ethers.account);
    const data = useSelector((state) => state.ethers.data);

    return (
        <>
            <div className="mt-4 flex flex-col lg:flex-row items-center justify-between">
                {account ? <>
                    <div className="w-full lg:w-1/2 mb-2 lg:mb-0">
                        <button
                            type="button"
                            onClick={connectMetaMask}
                            className="w-full flex justify-center items-center gap-2 bg-white text-sm text-gray-600 p-2 rounded-md hover:bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200 transition-colors duration-300"
                        >
                            {account ? `${data.balance} LINK` : 'Balance'} <MetaMaskIcon />
                        </button>
                    </div>
                    <div className="w-full lg:w-1/2 ml-0 lg:ml-2">
                        <button
                            type="button"
                            onClick={disconnectMetaMask}
                            className="w-full flex justify-center items-center gap-2 bg-white text-sm text-gray-600 p-2 rounded-md hover:bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200 transition-colors duration-300"
                        >
                            <MetaMaskIcon /> Disconnect
                        </button>
                    </div>
                </> : <div className="w-full">
                    <button
                        type="button"
                        onClick={connectMetaMask}
                        className="w-full flex justify-center items-center gap-2 bg-white text-sm text-gray-600 p-2 rounded-md hover:bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200 transition-colors duration-300"
                    >
                        <MetaMaskIcon /> Connect
                    </button>
                </div>}
            </div>
        </>
    );
};

export default MetaMaskButton;
